// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-admin-editor',
    data: () => ({
        nodes: [],
        isLoading: false
    }),
    created() {
        this.loadNodes();
    },
    methods: {
        async loadNodes() {
            this.$host.api.get('admin/settings/system').then(e => {
                this.nodes = e.data;
            });
        },
    }
});
// #endregion
